import { useContext, useEffect, useMemo, useState } from "react";
import { BlankMediaUserInfo } from "../../../generated/data-contracts";
import { BlankMediaUrls, api } from "../../../utils";
import { AvisLoader } from "../../shared/components";
import { LandingPage } from "../../shared/components/landingPage/LandingPage";
import { LandingPageAction } from "../../shared/components/landingPage/LandingPageAction";
import { AvisContext } from "../../shared/context/AvisContext";

export function LandingPageBlankMedia() {
  const { res } = useContext(AvisContext);
  const [loadingBlankMediaInfo, setLoadingBlankMediaInfo] =
    useState<boolean>(true);
  const [blankMediaUserInfo, setBlankMediaUserInfo] =
    useState<BlankMediaUserInfo>();

  useEffect(() => {
    setLoadingBlankMediaInfo(true);

    api
      .blankMediaUsersGetBlankMediaInfo()
      .then((res) => {
        setBlankMediaUserInfo(res.data);
      })
      .finally(() => setLoadingBlankMediaInfo(false));
  }, []);

  const newApplicationNavigateTarget = useMemo(() => {
    const useTypes = blankMediaUserInfo?.useTypes || [];

    if (useTypes.length === 0) return BlankMediaUrls.applicationViewNewI;

    const isImorterOrManufacturer =
      useTypes.indexOf("I") > -1 || useTypes.indexOf("R") > -1;

    //Importer or manufacturer role is more frequent
    return isImorterOrManufacturer
      ? BlankMediaUrls.applicationViewNewI
      : BlankMediaUrls.applicationViewNewP;
  }, [blankMediaUserInfo]);

  const conditionalTextToDisplayKeys = useMemo(() => {
    if (!blankMediaUserInfo) return [];

    const cKeys = [
      ...(blankMediaUserInfo.hasUnpaidInvoices
        ? ["portal_TDN_Start_UnpaidInvoices"]
        : []),
      ...(blankMediaUserInfo.hasRejectedReports
        ? ["portal_TDN_Start_RejectedReports"]
        : []),
      ...(blankMediaUserInfo.hasOverdueReports
        ? ["portal_TDN_Start_OverdueReports"]
        : []),
    ];

    return cKeys;
  }, [blankMediaUserInfo]);

  if (loadingBlankMediaInfo) return <AvisLoader />;

  return (
    <LandingPage
      title={res("blankMedia_LandingPage_WelcomeText")}
      textKey="portal_TDN_Start"
      conditionalTextKeys={conditionalTextToDisplayKeys}
    >
      <LandingPageAction
        buttonText={res("blankMedia_LandingPage_button_SubmissionList")}
        navigateTo={BlankMediaUrls.applicationsList}
        textKey={"portal_TDN_Start_ReportList"}
      />
      <LandingPageAction
        buttonText={res("blankMedia_LandingPage_button_NewSubmission")}
        navigateTo={newApplicationNavigateTarget}
        textKey={"portal_TDN_Start_NewReport"}
      />
    </LandingPage>
  );
}
